<template>
    <div class="quote_order_search_box">
        <!-- 标签页 -->
        <el-tabs 
            :value="selected_tabs"
            @tab-click="handleTabs"
            v-if="power != 111">
            <el-tab-pane
                v-for="(item, index) in tabsList"
                :key="index"
                :label="item.label"
                :name="item.value">
            </el-tab-pane>
        </el-tabs>
        <!-- 标题 -->
        <span class="quote_order_search_title">{{$t("message.cqorder.search1")}}</span>
        <!-- 开始时间 -->
        <el-date-picker
            v-model="start_date"
            type="date"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="startChange"
            :placeholder="$t('message.cqorder.search3')">
        </el-date-picker>
        <!-- 标题 -->
        <span class="quote_order_search_title">{{$t("message.cqorder.search2")}}</span>
        <!-- 结束时间 -->
        <el-date-picker
            v-model="end_date"
            type="date"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="endChange"
            :placeholder="$t('message.cqorder.search4')">
        </el-date-picker>
        <!-- 查询按钮 -->
        <el-button
            size="mini" 
            type="primary"
            @click="handleSearch"
            class="quote_order_search_btn">
            <span>{{$t("public.searchBtn")}}</span>
        </el-button>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        let selected_tabs = sessionStorage.getItem("selected_tabs") || "0",
        release = sessionStorage.getItem("release") || "",
        relend = sessionStorage.getItem("relend") || "";
        return {
            tabsList: [
                {
                    value: "0",
                    label: this.$t("message.cqorder.tab1")
                },
                {
                    value: "1",
                    label: this.$t("message.cqorder.tab2")
                },
                {
                    value: "2",
                    label: this.$t("message.cqorder.tab3")
                },
                {
                    value: "3",
                    label: this.$t("message.cqorder.tab4")
                },
            ],
            selected_tabs: selected_tabs,
            // 日期开始
            start_date: release,
            // 日期结束
            end_date: relend,
            // 日期选项的快捷选项绑定数据
            pickerOptions: {
                disabledDate:(time)=>{
                    return time.getTime() < new Date(this.start_date).getTime();
                }
            },
        }
    },
    computed: mapState({
        power: state => state.user.power,
    }),
    methods: {
        ...mapActions([
            "getQuoteOrderList"
        ]),
        handleTabs(tab, event) { // 切换标签页
            this.selected_tabs = tab.name;
            sessionStorage.setItem("selected_tabs", tab.name);
            this.handleSearch();
        },
        // 起始日期改变时
        startChange(val){
            sessionStorage.setItem("release", val);
            if(val == null){
                sessionStorage.removeItem("release")
            }
            if(this.end_date<this.start_date){
                this.end_date=""
            }
        },
        endChange(val){ // 日期选择器结束日期改变
            sessionStorage.setItem('relend', val)
            if(val == null){
                sessionStorage.removeItem("relend")
            }
        },
        handleSearch(){ // 搜索按钮
            this.$emit('handle-search')
        }
    },
}
</script>

<style scoped>
/* 组件盒子 */
.quote_order_search_box{
    padding: 20px;
    border-bottom: 1px solid #EBEEF5;
}
/* 标题 */
.quote_order_search_title{
    display: inline-block;
    margin: 0 5px 0 20px;
}
/* 按钮 */
.quote_order_search_btn{
    margin-left: 20px;
}
</style>
